import cx from "@/utils/cx";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import React from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

export interface InputProps<T extends FieldValues> {
  required?: boolean;
  name: Path<T>;
  control?: Control<T>;
  label?: string;
  placeholder?: string;
  slot?: any;
  className?: string;
  error?: string;
  disabled?: boolean;
  defaultValue?: string;
  options: { label: string; value: string }[];
}

function Select<T extends FieldValues>({
  required,
  name,
  control,
  label,
  placeholder,
  slot: S,
  defaultValue,
  className,
  disabled,
  error: errorMessage,
  options,
}: InputProps<T>) {
  return (
    <Controller
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched, isDirty, error },
      }) => {
        const e = errorMessage ?? error?.message;
        return (
          <div className="grid gap-1">
            {label && (
              <label
                className="text-sm font-medium text-primary"
                htmlFor={name}
              >
                {label}
              </label>
            )}

            <div className="relative">
              <select
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                ref={ref}
                name={name}
                id={name}
                className={cx(
                  "px-2.5 h-10 rounded-md border w-full border-neutral-300 focus:outline-grey-300 autofill:bg-white",
                  className
                )}
                defaultValue={defaultValue}
                disabled={disabled}
                placeholder={placeholder}
              >
                {options.map((option) => {
                  return (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  );
                })}
              </select>
              <ChevronDownIcon className="w-6 h-6 absolute right-1.5 top-1/2 -translate-y-1/2 z-10 pointer-events-none" />
            </div>
            {e && <p className="text-red-400 text-xs">{e}</p>}
          </div>
        );
      }}
      name={name}
      control={control}
      rules={{ required }}
    />
  );
}

export default Select;
